import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';

// Lazy load pages for better performance
import { lazy, Suspense } from 'react';
import { SkeletonCard } from '@/components/Skeleton';

const AuctionsPage = lazy(() => import('@/pages/Auctions'));
const AuctionDetailPage = lazy(() => import('@/pages/AuctionDetail'));
const CreateAuctionPage = lazy(() => import('@/pages/CreateAuction'));
const MyBidsPage = lazy(() => import('@/pages/MyBids'));
const WalletPage = lazy(() => import('@/pages/Wallet'));

function PageLoader() {
  return (
    <div className="space-y-4">
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
}

function withSuspense(Component: React.LazyExoticComponent<() => JSX.Element>) {
  return (
    <Suspense fallback={<PageLoader />}>
      <Component />
    </Suspense>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to="/auctions" replace />,
      },
      {
        path: 'auctions',
        element: withSuspense(AuctionsPage),
      },
      {
        path: 'auction/:id',
        element: withSuspense(AuctionDetailPage),
      },
      {
        path: 'create',
        element: withSuspense(CreateAuctionPage),
      },
      {
        path: 'my-bids',
        element: withSuspense(MyBidsPage),
      },
      {
        path: 'wallet',
        element: withSuspense(WalletPage),
      },
    ],
  },
]);
